import { Link } from "react-router-dom";
import BookCall from "@/components/BookCall";

export default function Call() {
  return (
    <div className="min-h-screen bg-ink text-cream" data-testid="call-page">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-10 sm:py-16">
        <Link to="/" className="font-serif text-3xl tracking-tight hover:text-gloss-gold transition-colors" data-testid="call-wordmark">S/ME</Link>
        <p className="overline text-gloss-gold mt-2 mb-8">The UK SME magazine — editorial desk</p>
        <BookCall />
        <p className="font-mono text-[10px] opacity-40 mt-6">
          Prefer to browse first? <Link to="/" className="underline hover:text-gloss-gold">Read the magazine</Link> · <Link to="/join" className="underline hover:text-gloss-gold">See membership</Link>
        </p>
      </div>
    </div>
  );
}
